import * as React from 'react'
import { isFlowTheme } from 'src/Libs/utils'

import EasterEggSvgIn from './EasterEggSvgIn'
import EasterEggSvgOut from './EasterEggSvgOut'

const OUT_COLORS_E3DC = ['#E0C8DC', '#5CC244', '#408830', '#832474', '#C9EBC1']
const OUT_COLORS_FLOW = ['#002841', '#8CCDFA', '#8CCDFA', '#8CCDFA', '#0078C3']

const IN_COLORS_E3DC = ['#C9EBC1', '#832474', '#5A8F1F', '#530048', '#5A8F1F']
const IN_COLORS_FLOW = ['#BEE7FF', '#004673', '#0078C3', '#002841', '#8CCDFA']

interface EasterEggProps {
  doRotateBy180Deg?: boolean
  direction: 'in' | 'out' | undefined
}

const EasterEgg: React.FC<EasterEggProps> = ({ doRotateBy180Deg = false, direction }) => {
  return direction === 'out' ? (
    <EasterEggSvgOut doRotateBy180Deg={doRotateBy180Deg} colors={isFlowTheme ? OUT_COLORS_FLOW : OUT_COLORS_E3DC} />
  ) : (
    <EasterEggSvgIn doRotateBy180Deg={doRotateBy180Deg} colors={isFlowTheme ? IN_COLORS_FLOW : IN_COLORS_E3DC} />
  )
}

export default EasterEgg
